import {NavLink} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {SubscriptionItem} from "../types.ts";

export const EditPageNavigation = ({component}: { component: SubscriptionItem }) => {

    const breadcrumbs = [
        {
            title: 'Home',
            href: '/dashboard',
        },
        {
            title: 'Subscription',
            href: `/subscriptions/${component.subscriptionId}`,
        },
        {
            title: 'Subscription Items',
            href: `/subscriptions/${component.subscriptionId}`,
        },
        {
            title: component.id
        }
    ].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
